export default "__VITE_ASSET__CC8vgFv0__"